import {
  Grid,
  IconButton,
  LinearProgress,
  Card,
  CardContent,
  Typography,
  Stack,
  Tooltip,
  Autocomplete,
  TextField,
  Divider,
  Chip,
  Link,
  Menu,
  MenuItem,
  ListItemIcon,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@emotion/react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { HiMenu } from "react-icons/hi";
import { BsFillFileEarmarkExcelFill, BsStopwatch } from "react-icons/bs";
import { AiOutlineTransaction } from "react-icons/ai";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ProductsOrder,
  setDialog,
  setLoading,
  setProductsOrdersDetailsDialog,
  setSearchBody,
  setSupplierChangeDialog,
  setTransactionsDialog,
} from "../../../../../app/slices/productsOrdersSlice";
import dayjs from "dayjs";
import { HiOutlineCube } from "react-icons/hi2";
import {
  MobileAction,
  MobileBadge,
  MobileEmpty,
  MobileListItem,
  MobileListShell,
  MobilePagination,
  TONE,
} from "../../../../../components/MobileList";
import { showNotification } from "../../../../../app/slices/notificationSlice";
import {
  MdOutlineClear,
  MdOutlinePublishedWithChanges,
  MdPayments,
} from "react-icons/md";
import DateRangepicker from "../../../../../helpers/dateRangePicker";
import ConfirmationDialog from "../../../../../helpers/ConfirmationDialog";
import ProductsOrdersForm from "../../from";
import { RiLoader2Fill } from "react-icons/ri";
import { CgDanger } from "react-icons/cg";
import { GiCardExchange } from "react-icons/gi";
import ProductOrdersTransactionsTable from "../transactions";
import { SelectProductsSupplier } from "../../../../../components/Selectors/SelectProductsSupplier";
import SupplierChangeForm from "../supplierChange";
import ProductsOrdersDetails from "../details";
import { SelectRepresentative } from "../../../../../components/Selectors/SelectRepresentative";
import { PointOfSales } from "../../../../../app/slices/posSlice";
import PosForm from "../../../../POS/form";
import { SelectSubCategory } from "../../../../../components/Selectors/SelectSubCategory";
import { SelectProducts } from "../../../../../components/Selectors/SelectProducts";

const ProductsOrdersTable = () => {
  const [search, setSearch] = useState({
    id: "",
    pos_name: "",
    pos_number: "",
    status: null,
    product_supplier_id: null,
    rep_id: null,
    start_date: null,
    end_date: null,
  });
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const _ProductsOrders = useSelector(
    (state) => state.productsOrders.productsOrders
  );
  const _ProductsOrder = useSelector(
    (state) => state.productsOrders.productsOrder
  );
  const loading = useSelector((state) => state.productsOrders.loading);
  const _SearchBody = useSelector((state) => state.productsOrders.searchBody);
  const _Transactions = useSelector(
    (state) => state.productsOrders.transactions
  );
  const _ProductsSupplier = useSelector(
    (state) => state.productSupplier.productsSupplier.data
  );
  const _ChangeSupplier = useSelector(
    (state) => state.productsOrders.supplierChange
  );
  const _ProductsOrderDetails = useSelector(
    (state) => state.productsOrders.productsOrdersDetails
  );
  const _PointsOfsales = useSelector((state) => state.pointOfsales.pos.dialog);
  const _SubCategory = useSelector(
    (state) => state.subCategories.subCategoriesList.data
  );
  const _Products = useSelector((state) => state.product.products.data);

  const [openConfirmApprove, setOpenConfirmApprove] = useState(false);
  const [openConfirmDailyPayments, setOpenConfirmDailyPayments] =
    useState(false);
  const [waiting, setWaiting] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const [isSuspend, setIsSuspend] = useState(false);
  const [dialogData, setDialogData] = useState("");
  const [dailyPaymentsData, setDailyPaymentsData] = useState("");

  const [activeItem, setActiveItem] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuClick = (event, item) => {
    setOpenMenu(event.currentTarget);
    setActiveItem(item);
  };

  const handleMenuClose = () => {
    setActiveItem(null);
    setOpenMenu(null);
  };

  const handleApproveClick = (params) => {
    if (params.status === "اقساط يومية") {
      dispatch(
        showNotification({
          message: "الطلب تمت الموافقة عليه مسبقاً",
          type: "success",
        })
      );
      setOpenConfirmApprove(false);
      setWaiting(false);
    } else {
      setOpenConfirmApprove(true);
      setDialogData(params);
      setWaiting(true);
    }
  };

  const handleRejectClick = (params) => {
    if (params.status === "رفض") {
      dispatch(
        showNotification({
          message: "الطلب تم رفضه مسبقاً",
          type: "success",
        })
      );
      setOpenConfirmApprove(false);
      setWaiting(false);
    } else {
      setOpenConfirmApprove(true);
      setDialogData(params);
      setWaiting(false);
    }
  };

  const handleCancelClick = (params) => {
    setOpenConfirmApprove(true);
    setDialogData(params);
    setCanceled(true);
  };

  const handleConfirmApprove = () => {
    if (waiting) {
      dispatch(
        ProductsOrder.changeStatus(
          {
            order_id: dialogData.id,
            status: "waiting",
          },
          _SearchBody
        )
      ).then((x) => setWaiting(false));
      setOpenConfirmApprove(false);
    } else if (canceled) {
      dispatch(
        ProductsOrder.cancelOrder(
          {
            order_id: dialogData.id,
          },
          _SearchBody
        )
      ).then((x) => setCanceled(false));
      setOpenConfirmApprove(false);
    } else {
      dispatch(
        ProductsOrder.changeStatus(
          {
            order_id: dialogData.id,
            status: "reject",
          },
          _SearchBody
        )
      ).then((x) => setWaiting(false));
      setOpenConfirmApprove(false);
    }
  };

  const handleCancelApprove = () => {
    setOpenConfirmApprove(false);
  };

  const handleDailyPaymentsClick = (params) => {
    setOpenConfirmDailyPayments(true);
    setDailyPaymentsData(params);
  };

  const handleConfirmDailyPayments = () => {
    dispatch(
      ProductsOrder.orderDailyPayments(
        {
          order_id: dailyPaymentsData.id,
        },
        _SearchBody
      )
    );
    setOpenConfirmDailyPayments(false);
  };

  const handleCancelDailyPayments = () => {
    setOpenConfirmDailyPayments(false);
  };

  const type = [
    { type: "paid", name: "تم التسديد" },
    // { type: "not", name: "لم يتم التسديد" },
    { type: "daily_payments", name: "اقساط يومية" },
    { type: "suspend", name: "متوقفة" },
    { type: "on_progress", name: "تحت المراجعة" },
    { type: "cancel_product_order", name: "الغاء طلب منصة" },
    { type: "reject", name: "رفض" },
  ];

  const operationMenu = (params) => (
    <Menu
      sx={{ direction: "rtl" }}
      anchorEl={openMenu}
      keepMounted
      id="products-order-menu"
      open={activeItem === params}
      onClose={handleMenuClose}
      onClick={handleMenuClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem
        onClick={() => dispatch(setProductsOrdersDetailsDialog(params))}
      >
        <ListItemIcon>
          <RiLoader2Fill size={22} />
        </ListItemIcon>
        تفاصيل الطلب
      </MenuItem>
      <MenuItem
        disabled={
          params.status !== "تحت المراجعة" && params.status !== "قيد الانتظار"
        }
        onClick={() => handleApproveClick(params)}
      >
        <ListItemIcon>
          <RiLoader2Fill size={22} />
        </ListItemIcon>
        انتظار الموافقة
      </MenuItem>
      <MenuItem
        disabled={
          params.status !== "تحت المراجعة" && params.status !== "قيد الانتظار"
        }
        onClick={() => {
          dispatch(
            setDialog({
              order_id: params.id,
              total_amount: params.total_amount,
              daily_payment: params.daily_payment,
            })
          );
          setIsSuspend(false);
        }}
      >
        <ListItemIcon>
          <MdOutlinePublishedWithChanges size={22} />
        </ListItemIcon>
        موافقة الطلب
      </MenuItem>
      <MenuItem
        disabled={params.status !== "اقساط يومية"}
        onClick={() => {
          dispatch(
            setDialog({
              order_id: params.id,
              total_amount: params.total_amount,
              daily_payment: params.daily_payment,
            })
          );
          setIsSuspend(true);
        }}
      >
        <ListItemIcon>
          <BsStopwatch size={22} />
        </ListItemIcon>
        ايقاف الاستقطاع
      </MenuItem>
      <MenuItem
        disabled={
          params.status !== "متوقفة" &&
          params.status !== "اقساط يومية" &&
          params.status !== "قيد الانتظار"
        }
        onClick={() => {
          dispatch(
            ProductsOrder.changeStatus(
              {
                order_id: params.id,
                status: "return_daily_payments",
              },
              _SearchBody
            )
          );
        }}
      >
        <ListItemIcon>
          <BsStopwatch size={22} />
        </ListItemIcon>
        استئناف الاستقطاع
      </MenuItem>
      <MenuItem
        disabled={
          params.status !== "تحت المراجعة" && params.status !== "قيد الانتظار"
        }
        onClick={() => handleRejectClick(params)}
      >
        <ListItemIcon>
          <CgDanger size={22} />
        </ListItemIcon>
        رفض الطلب
      </MenuItem>
      <MenuItem
        disabled={params.status !== "متوقفة"}
        onClick={() => handleCancelClick(params)}
      >
        <ListItemIcon>
          <CgDanger size={22} />
        </ListItemIcon>
        الغاء الطلب
      </MenuItem>
      <MenuItem
        disabled={params.status !== "اقساط يومية"}
        onClick={() => handleDailyPaymentsClick(params)}
      >
        <ListItemIcon>
          <MdPayments size={22} />
        </ListItemIcon>
        تشغيل اقساط يومية
      </MenuItem>
      <MenuItem onClick={() => dispatch(setTransactionsDialog(params.id))}>
        <ListItemIcon>
          <AiOutlineTransaction size={22} />
        </ListItemIcon>
        المناقلات المالية
      </MenuItem>
      <MenuItem
        onClick={() => {
          localStorage.setItem("isWholeSale", "0");
          window.open(
            "/app/wallets/transactions/" + params.pos_user_id,
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <AiOutlineTransaction size={22} />
        </ListItemIcon>
        محفظة النقطة
      </MenuItem>
      <MenuItem
        onClick={() => {
          dispatch(
            setSupplierChangeDialog({
              order_id: params.id,
              supplier_id: params.supplier_name,
            })
          );
        }}
      >
        <ListItemIcon>
          <GiCardExchange size={22} />
        </ListItemIcon>
        تغيير المجهز
      </MenuItem>
    </Menu>
  );

  const columns = [
    {
      field: "id",
      headerName: "رقم الطلب",
      flex: 0.6,
    },
    {
      field: "pos_name",
      headerName: "النقطة",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack>
            <Typography>
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  dispatch(setLoading("productsOrders"));
                  dispatch(PointOfSales.getById(params.row.pos_id)).then(() =>
                    dispatch(setLoading("productsOrders"))
                  );
                }}
              >
                {params.row?.pos_name}
              </Link>
            </Typography>
            <Typography variant="caption"> {params.row?.pos_number}</Typography>
          </Stack>
        );
      },
    },
    {
      field: "product_name",
      headerName: "اسم المنتج",
      flex: 1.4,
      renderCell: (params) => {
        return (
          <>
            <Tooltip
              title={<Typography noWrap>{params.row?.product_name}</Typography>}
            >
              <Typography noWrap>{params.row?.product_name}</Typography>
            </Tooltip>
            <Typography variant="caption" noWrap>
              {params.row?.supplier_name}
            </Typography>
          </>
        );
      },
    },
    {
      field: "count",
      headerName: "العدد",
      flex: 0.4,
    },
    {
      field: "total_amount",
      headerName: "سعر المنتج",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack>
            <Typography>
              الكلي: {params.row?.total_amount?.toLocaleString()}
            </Typography>
            <Typography variant="caption">
              اليومي: {params.row?.daily_payment?.toLocaleString()}
            </Typography>
          </Stack>
        );
      },
    },

    {
      field: "total_payments",
      headerName: "التسديد ",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack>
            <Typography>
              {" "}
              المسددة: {params.row?.total_payments?.toLocaleString()}
            </Typography>
            <Typography color="error">
              المتبقي: {params.row?.remaining?.toLocaleString()}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "revenue",
      headerName: "نسبة الشركة",
      flex: 0.7,
      renderCell: (params) => {
        return <Typography>{params.row?.revenue?.toLocaleString()}</Typography>;
      },
    },
    // {
    //   field: "remaining",
    //   headerName: "المبالغ المتبقية",
    //   flex: 1,
    //   renderCell: (params) => {
    //     return (
    //       <Typography>{params.row?.remaining.toLocaleString()}</Typography>
    //     );
    //   },
    // },
    {
      field: "created_by_user",
      headerName: "المستخدم المنشئ",
      flex: 1,
      renderCell: (params) => {
        return (
          <Tooltip
            title={
              <Typography noWrap>{params.row?.created_by_user}</Typography>
            }
          >
            <Typography noWrap>{params.row?.created_by_user ?? "-"}</Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "created_at",
      headerName: "تاريخ الطلب",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <Stack>
            <Typography variant="body2">
              {dayjs(params.row.created_at).format("YYYY-MM-DD")}
            </Typography>
            <Typography variant="caption">
              {dayjs(params.row.created_at).format("HH:mm")}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "status",
      headerName: "حالة الطلب",
      flex: 1,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={params.row.status}
            color={
              params.row.status === "تم التسديد"
                ? "success"
                : params.row.status === "رفض" ||
                  params.row.status === "الغاء طلب منصة"
                ? "error"
                : params.row.status === "اقساط يومية"
                ? "info"
                : "warning"
            }
          />
        );
      },
    },
    {
      field: "updated_at",
      headerName: "تاريخ التحديث",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <Stack>
            <Typography variant="body2">
              {dayjs(params.row.updated_at).format("YYYY-MM-DD")}
            </Typography>
            <Typography variant="caption">
              {dayjs(params.row.updated_at).format("HH:mm")}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "operations",
      headerName: "العمليات",
      type: "actions",
      flex: 0.5,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<RiLoader2Fill />}
          label="تفاصيل الطلب"
          onClick={() => {
            dispatch(setProductsOrdersDetailsDialog(params.row));
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<RiLoader2Fill />}
          label="انتظار الموافقة"
          disabled={
            params.row.status !== "تحت المراجعة" &&
            params.row.status !== "قيد الانتظار"
          }
          onClick={() => {
            handleApproveClick(params.row);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<MdOutlinePublishedWithChanges />}
          label="موافقة الطلب"
          disabled={
            params.row.status !== "تحت المراجعة" &&
            params.row.status !== "قيد الانتظار"
          }
          onClick={() => {
            dispatch(
              setDialog({
                order_id: params.row.id,
                total_amount: params.row.total_amount,
                daily_payment: params.row.daily_payment,
              })
            );
            setIsSuspend(false);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<BsStopwatch />}
          label="ايقاف الاستقطاع"
          disabled={params.row.status !== "اقساط يومية"}
          onClick={() => {
            dispatch(
              setDialog({
                order_id: params.row.id,
                total_amount: params.row.total_amount,
                daily_payment: params.row.daily_payment,
              })
            );
            setIsSuspend(true);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<BsStopwatch />}
          label="استئناف الاستقطاع"
          disabled={
            params.row.status !== "متوقفة" &&
            params.row.status !== "اقساط يومية" &&
            params.row.status !== "قيد الانتظار"
          }
          onClick={() => {
            dispatch(
              ProductsOrder.changeStatus(
                {
                  order_id: params.row.id,
                  status: "return_daily_payments",
                },
                _SearchBody
              )
            );
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<CgDanger />}
          label="رفض الطلب"
          disabled={
            params.row.status !== "تحت المراجعة" &&
            params.row.status !== "قيد الانتظار"
          }
          onClick={() => {
            handleRejectClick(params.row);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<CgDanger />}
          label="الغاء الطلب"
          disabled={params.row.status !== "متوقفة"}
          onClick={() => {
            handleCancelClick(params.row);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<MdPayments />}
          label="تشغيل اقساط يومية"
          disabled={params.row.status !== "اقساط يومية"}
          onClick={() => {
            handleDailyPaymentsClick(params.row);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<AiOutlineTransaction />}
          label="المناقلات المالية"
          onClick={() => {
            dispatch(setTransactionsDialog(params.row.id));
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<AiOutlineTransaction />}
          label="محفظة النقطة"
          onClick={() => {
            localStorage.setItem("isWholeSale", "0");
            window.open(
              "/app/wallets/transactions/" + params.row.pos_user_id,
              "_blank"
            );
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<GiCardExchange />}
          label="تغيير المجهز"
          onClick={() => {
            dispatch(
              setSupplierChangeDialog({
                order_id: params.row.id,
                supplier_id: params.row.supplier_name,
              })
            );
          }}
          showInMenu
        />,
      ],
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(ProductsOrder.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
  }, [_SearchBody, dispatch]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        id: search.id,
        pos_number: search.pos_number,
        pos_name: search.pos_name,
        rep_id: search.rep_id ?? "",
        start_date: search.start_date ?? "",
        end_date: search.end_date ?? "",
        status: search.status ?? "",
        sub_category_id: search.sub_category_id ?? "",
        product_supplier_id: search.product_supplier_id ?? "",
        product_id: search.product_id ?? "",
        skip: currentPage * pageSize,
        take: pageSize,
      })
    );
  }, [currentPage, dispatch, pageSize, search]);

  return (
    <Card>
      <CardContent>
        {activeItem && operationMenu(activeItem)}
        <Box>
          {_ProductsOrder.dialog && (
            <ProductsOrdersForm isSuspend={isSuspend} />
          )}
          {_Transactions.dialog && <ProductOrdersTransactionsTable />}
          {_ChangeSupplier.dialog && <SupplierChangeForm />}
          {_ProductsOrderDetails.dialog && <ProductsOrdersDetails />}
          {_PointsOfsales && <PosForm inNeedReload={false} />}
          <ConfirmationDialog
            type="confirm"
            open={openConfirmApprove}
            title="تاكيد"
            message={
              waiting
                ? "هل انت متاكد من تحويل الطلب الى الانتظار"
                : canceled
                ? "هل انت متاكد من الغاء الطلب المرقم"
                : "هل انت متاكد من رفض الطلب المرقم"
            }
            name={dialogData.id}
            confirmText="تاكيد"
            cancelText="الغاء"
            onConfirm={handleConfirmApprove}
            onCancel={handleCancelApprove}
          />
          <ConfirmationDialog
            type="confirm"
            open={openConfirmApprove}
            title="تاكيد"
            message={
              waiting
                ? "هل انت متاكد من تحويل الطلب الى الانتظار"
                : "هل انت متاكد من رفض الطلب المرقم"
            }
            name={dialogData.id}
            confirmText="تاكيد"
            cancelText="الغاء"
            onConfirm={handleConfirmApprove}
            onCancel={handleCancelApprove}
          />
          <ConfirmationDialog
            type="confirm"
            open={openConfirmDailyPayments}
            title="تاكيد"
            message={"هل انت متاكد من تشغيل الاقساط اليومية للطلب المرقم"}
            name={dailyPaymentsData.id}
            confirmText="تاكيد"
            cancelText="الغاء"
            onConfirm={handleConfirmDailyPayments}
            onCancel={handleCancelDailyPayments}
          />
        </Box>
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              size="small"
              value={search.pos_name || search.pos_number}
              onChange={(e) => {
                if (isNaN(e.target.value)) {
                  setSearch({
                    ...search,
                    pos_name: e.target.value,
                    pos_number: "",
                  });
                } else {
                  setSearch({
                    ...search,
                    pos_number: e.target.value,
                    pos_name: "",
                  });
                }
              }}
              label="رقم نقطة البيع او اسمها"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              size="small"
              value={search.id}
              onChange={(e) => {
                setSearch({
                  ...search,
                  id: e.target.value,
                });
              }}
              label="رقم الطلب"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectProductsSupplier
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  product_supplier_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _ProductsSupplier?.filter(
                  (x) => x.id === search.product_supplier_id
                )[0]
                  ? _ProductsSupplier?.filter(
                      (x) => x.id === search.product_supplier_id
                    )[0]
                  : search.product_supplier_id
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectSubCategory
              isproduct
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  sub_category_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _SubCategory.filter((x) => x.id === search.sub_category_id)[0]
                  ? _SubCategory.filter(
                      (x) => x.id === search.sub_category_id
                    )[0]
                  : search.sub_category_id
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              options={type}
              getOptionLabel={(option) => {
                return option.name;
              }}
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  status: newValue ? newValue.type : null,
                });
              }}
              value={
                type.filter((x) => x.type === search.status)[0]
                  ? type.filter((x) => x.type === search.status)[0]
                  : null
              }
              renderInput={(params) => (
                <TextField {...params} label="حالة الطلب" size="small" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectRepresentative
              disabled={loading}
              onChange={(event, value) => {
                setSearch({
                  ...search,
                  rep_id: value ? value.id : null,
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectProducts
              onChange={(event, value) => {
                setSearch({
                  ...search,
                  product_id: value ? value.id : null,
                });
              }}
              value={
                _Products.filter((x) => x.id === search.product_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.start_date}
              endDate={search.end_date}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    start_date: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={0} sx={{ alignItems: "center" }}>
              <Tooltip title="تصدير ملف اكسل">
                <IconButton
                  onClick={() => {
                    dispatch(ProductsOrder.exportExcel(_SearchBody));
                  }}
                >
                  <BsFillFileEarmarkExcelFill />
                </IconButton>
              </Tooltip>

              <Tooltip title="الغاء الفلتر">
                <IconButton
                  onClick={() => {
                    setSearch({
                      id: "",
                      pos_name: "",
                      pos_number: "",
                      status: null,
                      product_supplier_id: null,
                      sub_category_id: null,
                      start_date: null,
                      end_date: null,
                    });
                    setPageSize(15);
                    setCurrentPage(0);
                  }}
                >
                  <MdOutlineClear />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={{ xs: 1, md: 4 }}
            >
              <Typography variant="h4">
                المجموع الكلي للطلبات :{" "}
                {(typeof _ProductsOrders.total_amount === "number"
                  ? _ProductsOrders.total_amount
                  : Number(_ProductsOrders.total_amount) || 0
                )?.toLocaleString()}{" "}
                (IQD)
              </Typography>
              <Typography variant="h4">
                مجموع المبالغ المدفوعة :{" "}
                {(typeof _ProductsOrders.total_payments === "number"
                  ? _ProductsOrders.total_payments
                  : Number(_ProductsOrders.total_payments) || 0
                )?.toLocaleString()}{" "}
                (IQD)
              </Typography>
              <Typography variant="h4">
                مجموع المبالغ المتبقية :{" "}
                {(typeof _ProductsOrders.total_remaining === "number"
                  ? _ProductsOrders.total_remaining
                  : Number(_ProductsOrders.total_remaining) || 0
                )?.toLocaleString()}{" "}
                (IQD)
              </Typography>
            </Stack>
          </Grid>
          {smallScreen ? (
            <Grid item xs={12}>
              <MobileListShell loading={loading}>
                {_ProductsOrders?.data?.length > 0 ? (
                  <>
                    {_ProductsOrders.data.map((order, index) => (
                      <MobileListItem
                        key={index}
                        avatar={<HiOutlineCube />}
                        title={`طلب #${order.id}`}
                        subtitle={`${order?.product_name ?? ""} · ${dayjs(
                          order.created_at
                        ).format("YYYY-MM-DD")}`}
                        badge={
                          <MobileBadge
                            label={order.status}
                            tone={
                              order.status === "تم التسديد"
                                ? TONE.success
                                : order.status === "رفض" ||
                                  order.status === "الغاء طلب منصة"
                                ? TONE.danger
                                : order.status === "اقساط يومية"
                                ? TONE.brand
                                : TONE.warning
                            }
                          />
                        }
                        highlight={{
                          label: "السعر الكلي",
                          value: (order?.total_amount ?? 0).toLocaleString(),
                          unit: "IQD",
                        }}
                        fields={[
                          {
                            label: "النقطة",
                            span: 12,
                            value: (
                              <Link
                                component="button"
                                type="button"
                                sx={{ fontWeight: 600 }}
                                onClick={() => {
                                  dispatch(setLoading("productsOrders"));
                                  dispatch(
                                    PointOfSales.getById(order.pos_id)
                                  ).then(() =>
                                    dispatch(setLoading("productsOrders"))
                                  );
                                }}
                              >
                                {order?.pos_name}
                              </Link>
                            ),
                          },
                          { label: "رقم النقطة", value: order?.pos_number },
                          { label: "المجهز", value: order?.supplier_name },
                          { label: "العدد", value: order?.count },
                          {
                            label: "القسط اليومي",
                            value: order?.daily_payment?.toLocaleString(),
                          },
                          {
                            label: "المسددة",
                            value: order?.total_payments?.toLocaleString(),
                          },
                          {
                            label: "المتبقي",
                            value: order?.remaining?.toLocaleString(),
                          },
                          {
                            label: "نسبة الشركة",
                            value: order?.revenue?.toLocaleString(),
                          },
                          {
                            label: "المستخدم المنشئ",
                            span: 12,
                            value: order?.created_by_user,
                          },
                          {
                            label: "تاريخ التحديث",
                            span: 12,
                            value: dayjs(order.updated_at).format(
                              "HH:mm / YYYY-MM-DD"
                            ),
                          },
                        ]}
                        actions={
                          <>
                            <MobileAction
                              title="العمليات"
                              tone={TONE.neutral}
                              icon={<HiMenu />}
                              onClick={(e) => handleMenuClick(e, order)}
                            />
                            <MobileAction
                              title="تفاصيل الطلب"
                              icon={<RiLoader2Fill />}
                              onClick={() =>
                                dispatch(setProductsOrdersDetailsDialog(order))
                              }
                            />
                            <MobileAction
                              title="المناقلات المالية"
                              tone={TONE.success}
                              icon={<AiOutlineTransaction />}
                              onClick={() =>
                                dispatch(setTransactionsDialog(order.id))
                              }
                            />
                          </>
                        }
                      />
                    ))}
                    <MobilePagination
                      count={_ProductsOrders.total ?? 0}
                      rowsPerPage={pageSize}
                      page={currentPage}
                      onPageChange={(e, newPage) => setCurrentPage(newPage)}
                      rowsPerPageOptions={[15, 25, 50, 100]}
                      onRowsPerPageChange={(event) => {
                        setPageSize(parseInt(event.target.value, 10));
                      }}
                    />
                  </>
                ) : (
                  <MobileEmpty />
                )}
              </MobileListShell>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Box sx={{ height: "65vh", width: "100%" }}>
                {_ProductsOrders.data ? (
                  <DataGrid
                    rows={_ProductsOrders.data}
                    columns={columns}
                    pageSize={pageSize}
                    page={currentPage}
                    rowCount={_ProductsOrders.total}
                    loading={loading}
                    rowHeight={50}
                    pagination
                    paginationMode="server"
                    selectionModel={[]}
                    onPageChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                    rowsPerPageOptions={[15, 25, 50, 100]}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                    }}
                    components={{
                      LoadingOverlay: LinearProgress,
                    }}
                  />
                ) : (
                  <LinearProgress />
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ProductsOrdersTable;
